import { Link } from "react-router";

import { COMPONENT_DETAILS_PATHS } from "@/components/pages_logged_in/program/components/component-utils";
import { Button, ButtonIntent } from "@/components/ui/button";
import { ComponentTypeEnum } from "@/graphql";
import {
  LeadComponent,
  MainComponent,
  ParticipantComponent,
  StatisticComponent,
} from "@/types/programs";

type ProgramComponent = (
  | MainComponent
  | ParticipantComponent
  | LeadComponent
  | StatisticComponent
) & {
  parentComponent?: ParticipantComponent["parentComponent"];
};

interface ViewComponentButtonProps {
  component: ProgramComponent;
  programId: string;
  intent?: ButtonIntent;
  isProgramLead?: boolean;
  fill?: boolean;
}

export function ViewComponentButton({
  component,
  programId,
  intent = "primary",
  isProgramLead = false,
  fill = false,
}: ViewComponentButtonProps) {
  if (!isProgramLead) return null;

  const path = COMPONENT_DETAILS_PATHS[component.type];

  let componentId = component?.id;

  if (
    [
      ComponentTypeEnum.OneOneCoachingIntro,
      ComponentTypeEnum.OneOneCoachingSession,
    ].includes(component?.type)
  ) {
    componentId = component?.parentComponent?.id || "";
  }

  return (
    <div>
      <Button
        asChild
        intent={intent}
        size="lg"
        className={`h-auto px-9 py-2.5 ${fill ? "w-full" : ""}`}
      >
        <Link to={`/programs/${programId}/${path}/${componentId}`}>
          View Details
        </Link>
      </Button>
    </div>
  );
}
